import { CloudflareAsset, ErrorMessages } from "@/shared/common/enums";
import type { IButtonTypes } from "@/shared/common/types";
import { CloudFlareImage } from "@/shared/components";
import { Button } from "@ab.uitools/ui-library/components/Button";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  title?: string;
  subtitle?: string;
  buttonType?: IButtonTypes;
  buttonTitle?: string;
  buttonIcon?: (props: ISVGIconProps) => ReactElement;
  action?: () => void;
  isError?: boolean;
  isShowButton?: boolean;
  isShowSubtitle?: boolean;
  illustration?: CloudflareAsset;
}

export const EmptyOrErrorContent = (
  {
    title,
    subtitle,
    buttonType = "secondary",
    buttonTitle = "general.reload",
    buttonIcon = (props: ISVGIconProps) => (
      <CloudFlareImage {...props} path={CloudflareAsset.Refresh}/>
    ),
    isError = false,
    isShowButton = true,
    action,
    illustration = CloudflareAsset.EmptyContent,
  }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flexbox flex-direction--column align-items--center full-width empty-content">
      <CloudFlareImage
        className="empty-content__image"
        path={illustration}
      />
      <Text
        className="mt-8 text-center empty-content__title"
        weight="bolder"
        size="medium"
        lineHeight="large"
      >
        {title || t(isError ? ErrorMessages.TryAgainShortly : "general.noData")}
      </Text>
      {subtitle && (
        <Text type="secondary" className="text-center empty-content__subtitle">
          {subtitle}
        </Text>
      )}
      {isShowButton && (
        <Button
          type={buttonType}
          size="medium"
          className="mt-12"
          onClick={action}
          data-testid="empty-content-action-button"
          data-ga-id="empty-content-action-button"
          data-ga-action="Empty content action button"
          iconProps={{
            Component: buttonIcon,
            size: "small",
            alignment: "left",
          }}
        >
          {t(buttonTitle)}
        </Button>
      )}
    </div>
  );
};
